import { getAxiosInstance } from "../ApiConfig";

async function tasktypeApi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTaskType`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function taskstatusApi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTaskStatus`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllTaskList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTasksByReportingUsers`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllTaskPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTasksByReportingUsers?page=${page}&limit=${limit}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllTaskSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTasksByReportingUsers?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllTaskPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTasksByReportingUsers?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllRelatedTask(type, id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllRelatedTasks/${type}/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function TaskDeatailsApi(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByTaskId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function TasksSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createTasks`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function TaskUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateTasks/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function massUpdateTask(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/massUpdateTask`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massDeleteTasks(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/massDeleteTasks`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    massUpdateTask,
    massDeleteTasks,
    tasktypeApi,
    taskstatusApi,
    AllTaskList,
    AllRelatedTask,
    TaskUpdate,
    AllTaskPagination,
    AllTaskPaginationSearch,
    FetchAllTaskSearch,
    TaskDeatailsApi,
    TasksSave,
}